import React, { useEffect } from 'react';
import emailjs from '@emailjs/browser';
import './PaymentSuccess.css';

const PaymentSuccess = () => {
  useEffect(() => {
    emailjs.send(
      process.env.REACT_APP_EMAIL_JS_SERVICE_ID,
      process.env.REACT_APP_EMAIL_JS_TEMPLATE_ID,
      {},
      process.env.REACT_APP_EMAIL_JS_PUBLIC_key
    ).catch((err) => console.error('שגיאה בשליחת מייל:', err));
  }, []);

  return (
    <div className="success-page">
      <div className="success-icon">
        <svg viewBox="0 0 24 24">
          <polyline points="20 6 9 17 4 12" />
        </svg>
      </div>

      <h1 className="success-title">מזל טוב! 🎉</h1>

      <p className="success-subtitle">
        הרכישה עברה בהצלחה — את רשמית בעניינים
      </p>
      <p className="success-note">
        שלחנו לך מייל עם כל הפרטים.<br />
        תפתחי אותו, הכל שם 💌
      </p>

      <div className="success-divider" />

      <div className="success-actions">
        <a href="/profile/history" className="success-btn-primary">לרכישות שלי</a>
        <a href="/" className="success-btn-secondary">לדף הבית</a>
      </div>
    </div>
  );
};

export default PaymentSuccess;
